import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
// Bootstrap first, then our app overrides — so index.css (brand font, etc.)
// wins over Bootstrap's own `body`/variable defaults instead of being overridden.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { PwaUpdateProvider } from './contexts/PwaUpdateContext';
import { AuthProvider } from './contexts/AuthContext';
import { ScoutingStateProvider } from './contexts/ScoutingStateContext';
import { ConnectivityProvider } from './contexts/ConnectivityContext';
import { initSentry } from './utils/sentryInit';
// Import i18n so it initialises before the React tree mounts
import './i18n';

// Must run before the React tree mounts so all errors are captured
initSentry();

axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    // If a request succeeds and we are in reachable mode, we could trigger a check
    // but the heartbeat/initial check already handles 'online' transitions.
    return response;
  },
  (error) => {
    // Check for network errors (no response from server)
    if (!error.response || error.code === 'ECONNABORTED' || error.message === 'Network Error') {
      window.dispatchEvent(new CustomEvent('check-reachability'));
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConnectivityProvider>
      <ScoutingStateProvider>
        <PwaUpdateProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </PwaUpdateProvider>
      </ScoutingStateProvider>
    </ConnectivityProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('pwa-update-available', { detail: registration }));
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
